import React from 'react';
import { PurchaseSummary } from '../../../types/purchases/BasePurchase';
import PurchaseTableModal from '../../Tables/PurchaseTableModal';
import PurchaseSummaryCard from '../common/PurchaseSummaryCard';
import SvgIcon from '../../SvgIcon/SvgIcon';

interface FinalizedPurchaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  purchases: PurchaseSummary[];
  onSettle: (purchase: PurchaseSummary) => void;
}

const FinalizedPurchaseModal: React.FC<FinalizedPurchaseModalProps> = ({
  isOpen,
  onClose,
  purchases,
  onSettle,
}) => {
  return (
    <PurchaseTableModal
      isOpen={isOpen}
      onClose={onClose}
      title="Compras por Asentar"
      maxWidth="max-w-3xl"
    >
      <div className="max-h-[500px] overflow-y-auto p-4 sm:p-6">
        {purchases.length === 0 ? (
          <div className="text-gray-500 dark:text-gray-400 flex flex-col items-center gap-3 py-10 text-center text-sm">
            <SvgIcon name="settle-products" width={32} height={32} className="opacity-40" />
            No hay compras finalizadas pendientes de asentar.
          </div>
        ) : (
          <div className="flex flex-col gap-3">
            {purchases.map((item) => (
              <PurchaseSummaryCard
                key={item.id}
                purchase={item}
                actions={
                  <button
                    className="flex items-center justify-center gap-2 rounded bg-primary px-3 py-2 text-sm font-medium text-white hover:bg-opacity-90"
                    onClick={() => onSettle(item)}
                  >
                    <SvgIcon name="settle-products" width={16} height={16} />
                    Asentar productos
                  </button>
                }
              />
            ))}
          </div>
        )}
      </div>
    </PurchaseTableModal>
  );
};

export default FinalizedPurchaseModal;
